import { FormControl } from "@angular/forms";
import { messages } from "../resources/messages";

export const passwordRequiredSpecialCharacters = "-+_!@#$%^&*.,?";

/**
 * @param control The form control to validate
 * @description The validated password must contain at least 1 upper or lower case character,
 * 1 number, and have 6 characters min length. Special letters are allowed
 */
export const passwordValid = (control: FormControl) => {
    if (!control.value) {
        return { passwordInvalid: messages.validation.passwordInvalid };
    }

    const notMatchMinlength = control.value.length < 8;
    const hasUpperAndLowerAndDigit = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/.test(control.value);
    const hasSpecialChar = new RegExp(`[${passwordRequiredSpecialCharacters}]`).test(control.value);

    if (notMatchMinlength || !hasUpperAndLowerAndDigit || !hasSpecialChar) {
        return { passwordInvalid: messages.validation.passwordInvalid };
    }
};
